import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import thunk from 'redux-thunk';
import reducer from './redux/reducer';
import { migrations, PERSIST_VERSION } from './redux/migrations';
import storage from './redux/safe-storage';

const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'root',
  storage,
  version: PERSIST_VERSION,
  migrate: createMigrate(migrations, { debug: false })
};

const persistedReducer = persistReducer(persistConfig, reducer);
const enhancers = storeEnhancers(applyMiddleware(thunk));
const store = createStore(persistedReducer, enhancers);
const persistor = persistStore(store);

export { store, persistor };
